<!-- 由 suu 创建于 2025-03-04 星期二 -->
<template>
  <div class="DetailExceedPop">
    <!-- 超练弹窗 -->
    <div class="exceed-title">重要提示</div>
    <div class="exceed-cent">
      <div class="ex-cent-title">《{{ overTips.title }}》</div>
      <div class="ex-cent-text">
        <div>尊敬的会员 {{ overTips.truename }}您好：</div>
        <div class="ex_ct_indent">
          我们有注意到，您在最近三十天（{{ this.overTips.s_date }}至
          {{ this.overTips.e_date }}期间），预约到店锻炼的次数
          <span>已达{{ this.overTips.over_count }}次</span>
          ，为了您的身体健康，
          <span>我们建议您：短时间内不宜高频次锻炼</span>
          。望您慎重考虑本次是否继续参加锻炼，如您继续锻炼，我们将继续为您提供专业教练一对一指导服务，但在锻炼过程中或锻炼完成后，您身体发生的任何不适现象，我们无法给您保障或任何形式的赔偿、补偿，请知晓！
        </div>
        <div class="ex_ct_indent ex_ct_top">
          <span
            >以上风险【{{
              overTips.shop_name
            }}】已详细向我告知，本人完全理解，但本人坚持继续完成本次锻炼，如有身体不适，与【{{
              overTips.shop_name
            }}】无关。</span
          >
        </div>
        <div class="ex_ct_right">时间：{{ overTips.e_date }}</div>
      </div>
    </div>
    <div class="ex-soc-check">
      <input @change="handleChange" type="checkbox" />
      <div class="soc-agreement">我已理解及同意以上协议内容</div>
    </div>
    <div class="ex-btns">
      <div class="ex-btns-item ex-btns-item2" @click="handleCancel">取消</div>
      <div
        :class="[
          !checkValue || vContent
            ? 'ex-btns-item1'
            : 'ex-btns-item1 ex-btns-item1-on'
        ]"
        @click="handleConfirm"
      >
        确定<span v-if="vContent">（{{ vContent }}）</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailExceedPop',

  components: {},

  props: {
    overTips: {},
    vContent: {}
  },

  data() {
    return {
      checkValue: false
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    handleChange() {
      this.checkValue = !this.checkValue
      this.$emit('checkChange', this.checkValue)
    },
    handleConfirm() {
      if (!this.checkValue) {
        this.$toast('请先同意以上协议内容')
        return
      }
      this.$emit('confirm')
    },
    handleCancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.DetailExceedPop {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #050b27;
  background: #f7f7f7;
  padding: 0 vw(10);
  box-sizing: border-box;
  padding-bottom: vw(36);
  .exceed-title {
    width: 100%;
    padding: 0 vw(10);
    box-sizing: border-box;
    font-weight: 600;
    font-size: 20px;
    color: #050b27;
    line-height: 28px;
    margin-top: vw(26);
  }
  .exceed-cent {
    width: 100%;
    box-sizing: border-box;
    overflow-y: scroll;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #f1f1f1;
    padding: vw(20);
    padding-right: vw(24);
    padding-bottom: vw(12);
    margin-top: vw(10);
    text-align: left;
    font-weight: 300;
    font-size: 12px;
    color: rgba(5, 11, 39, 0.8);
    line-height: 20px;
    .ex-cent-title {
      font-weight: 400;
      font-size: 16px;
      color: rgba(5, 11, 39, 0.5);
      line-height: 22px;
    }
    .ex-cent-text {
      box-sizing: border-box;
      font-weight: 500;
      margin-top: vw(12);
      height: fit-content;
      &::-webkit-scrollbar {
        width: 0;
        height: 0;
      }
      span {
        font-weight: 600;
        color: #050b27;
      }
      .ex_ct_indent {
        text-indent: 2em;
      }
      .ex_ct_top {
        margin-top: vw(8);
      }
      .ex_ct_right {
        text-align: right;
        margin-right: 1em;
      }
    }
  }
  .ex-soc-check {
    width: 100%;
    box-sizing: border-box;
    padding: 0 vw(10);
    display: flex;
    align-items: center;
    margin-top: vw(21);
    .soc-agreement {
      font-size: vw(12);
      color: #050b27;
      font-weight: 600;
      margin-left: vw(13);
      // line-height: vw(17);
    }
    input[type='checkbox'] {
      width: vw(10);
      height: vw(10);
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      vertical-align: middle;
      line-height: vw(20);
      position: relative;
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      // border-radius: vw(6);
      background-color: transparent;
    }
    input[type='checkbox']::before {
      content: '';
      position: absolute;
      // top: 0;
      // left: 0;
      background: #f7f7f7;
      width: vw(20);
      height: vw(20);
      border: 1px solid #e7e7e7;
      box-sizing: border-box;
      border-radius: vw(4);
    }
    input[type='checkbox']:checked::before {
      content: '\2713';
      background: #ffffff;
      position: absolute;
      // top: 0;
      // left: 0;
      width: vw(20);
      height: vw(20);
      border: 1px solid #ff2270;
      color: #ff2270;
      font-size: vw(13);
      box-sizing: border-box;
      font-weight: bold;
      border-radius: vw(4);
    }
  }
  .ex-btns {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: vw(29);
    .ex-btns-item2 {
      width: 130px;
      height: 44px;
      background: #ffffff;
      border-radius: 4px;
      font-weight: 300;
      font-size: 16px;
      color: #050b27;
      line-height: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .ex-btns-item1 {
      width: 220px;
      height: 44px;
      background: #dddddd;
      border-radius: 4px;
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      line-height: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .ex-btns-item1-on {
      background: #ff2270;
      box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
